import { render, staticRenderFns } from "./OrderListTable.vue?vue&type=template&id=33c57ff2&scoped=true&"
import script from "./OrderListTable.vue?vue&type=script&lang=js&"
export * from "./OrderListTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderListTable.vue?vue&type=style&index=0&id=33c57ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c57ff2",
  null
  
)

export default component.exports